import React from "react";
import { Box, Typography, Link } from "@mui/material";

export const Footer = () => {
  return (
    <>
     <Box sx={{ background: "linear-gradient(to right, #F83901, #FCE26F)", width: "100%", height: "5px" }} />

     <Box display="flex" justifyContent="center" alignItems="center" sx={{ backgroundColor: "#f1f1f1", width: "100%", paddingTop: "25px", paddingBottom: "25px" }} component="footer">
        <Typography variant="body1">DEVEX ApS - Vestergårdsvangen 128, 8260 Viby J, CVR: 44696835, Mail: www-kontakt@devex.dk </Typography>
     </Box>
   </>  
  );
};